"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { LuFileText } from "react-icons/lu";
import DocumentViewDialog from "@/components/patient/documents/document-view-dialog";
import { Divider } from "@/components/ui";
import { formatDate, formatToHumanReadable } from "@/lib/format-data";
import { DocumentSummary } from "@/types/document";
import { PatientSidebarSectionSkeleton } from "./section-skeleton";
import { documentQueryOptions } from "@/api/provider/user/patient/document-query";
interface Props {
  patientId: string;
}
export default function DocumentsSection(t0) {
  const $ = _c(21);
  const {
    patientId
  } = t0;
  let t1;
  if ($[0] !== patientId) {
    t1 = documentQueryOptions.list(patientId);
    $[0] = patientId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!patientId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: t4,
    isLoading
  } = useQuery(t3);
  let t5;
  if ($[5] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const documents = t5;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  if (isLoading) {
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <PatientSidebarSectionSkeleton />;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  if (!documents || documents.length === 0) {
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <p className="text-caption text-muted-foreground">No documents, upload one to get started</p>;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    return t6;
  }
  let t6;
  if ($[9] !== documents) {
    let t7;
    if ($[11] !== documents.length) {
      t7 = (document, index) => <div key={document.id} className="mb-3 cursor-pointer rounded-md p-1 hover:bg-background-secondary" onClick={() => {
        setSelectedDocument(document);
        setIsOpen(true);
      }}><div className="flex items-center gap-1.5"><p className="truncate text-body-strong text-foreground">{document.title}</p>{document.noteIds?.length > 0 && <LuFileText className="h-3.5 w-3.5 shrink-0 text-accent-foreground" title={`Linked to ${document.noteIds.length} note${document.noteIds.length !== 1 ? "s" : ""}`} />}</div><p className="text-caption text-foreground-secondary">Type: {formatToHumanReadable(document.docType)}</p>{"summary" in document && document.summary && <p className="truncate text-caption text-foreground-secondary">{document.summary}</p>}{"createdDate" in document && document.createdDate ? <p className="text-caption text-foreground-secondary">{formatDate(new Date(document.createdDate as string))}</p> : null}{index !== documents.length - 1 && <Divider className="my-2" />}</div>;
      $[11] = documents.length;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    t6 = documents.map(t7);
    $[9] = documents;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <div className="max-h-60 overflow-y-auto">{t6}</div>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== isOpen || $[16] !== selectedDocument) {
    t8 = <DocumentViewDialog isOpen={isOpen} onOpenChange={setIsOpen} document={selectedDocument} />;
    $[15] = isOpen;
    $[16] = selectedDocument;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}